import { CheckCircle2, ClipboardList, Loader2, Scale } from "lucide-react"
import { useTranslation } from "react-i18next"

import { KpiCard } from "@/components/kpi-card"
import { bucketForOrderStatus } from "@/features/orders/lib/order-status"
import { kgToMt, formatNumber } from "@/lib/format"
import type { OrderListItem } from "@/types/domain"

export function OrdersKpiStrip({ orders }: { orders: OrderListItem[] }) {
  const { t } = useTranslation(["orders", "common"])

  const total = orders.length
  let inProgress = 0
  let completed = 0
  for (const o of orders) {
    const bucket = bucketForOrderStatus(o.orderStatus)
    if (bucket === "inProgress") inProgress += 1
    else if (bucket === "completed") completed += 1
  }
  const totalVolumeMt = orders.reduce(
    (sum, o) => sum + kgToMt(o.agreedQuantity ?? 0),
    0,
  )

  const mt = t("units.mt", { ns: "common" })

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <KpiCard
        label={t("kpis.total")}
        value={formatNumber(total)}
        icon={ClipboardList}
        tone="info"
      />
      <KpiCard
        label={t("statusBucket.inProgress")}
        value={formatNumber(inProgress)}
        icon={Loader2}
        tone="warning"
      />
      <KpiCard
        label={t("statusBucket.completed")}
        value={formatNumber(completed)}
        icon={CheckCircle2}
        tone="success"
      />
      <KpiCard
        label={t("kpis.totalVolume")}
        value={`${formatNumber(totalVolumeMt)} ${mt}`}
        icon={Scale}
        tone="muted"
      />
    </div>
  )
}
